'use strict';

class Calculate {
    place_index = 0;
    place_count = 0;
    res_container  = document.getElementById('result_list');

    calculate(form){
        $(form).on('beforeSubmit', (e) => {
            //e.preventDefault();
            ym(73234981,'reachGoal','event_click_calculate');
            
            $(this.res_container).find('.empty_result').slideUp();
            $(this.res_container).find('.result').slideUp();
            $(this.res_container).find('.loader-circle').fadeIn();

            let el = document.getElementById('result_list');

            el.scrollIntoView({
                behavior: "smooth"
            });


            let url = '/ajax/calculate-cod'
            let data = $(form).serializeArray();
            let callback = (result) => {
                this.pushResult(result);
            };

            data.push({
                name: 'place_count',
                value: this.place_count
            })

            let request = new Ajax({
                url: url,
                data: data,
                callback: callback
            })

            request.ajaxRequest();

            return false;
        });
    }

    createNewPlace(callback) {
        this.place_index++;
        this.place_count++;

        let url = '/ajax/create-new-place'

        let request = new AjaxParts('#places', {
            url:url,
            data: {place_index: this.place_index},
            callback:callback
        });

        request.ajaxRequest();
    }

    removePlace(place_index) {
        $('div[data-place-index="' + place_index + '"]').remove();

        this.place_count--;

        this.setPlacesIndexNumber();
        this.calculatePlacesWeightAndVolume();
    }

    setPlacesIndexNumber(){
        $('.place-count').each(function (index, e) {
            $(e).html(index + 1);
        })
    }

    calculateVolume(fields) {
        let result = 1;

        fields.each(function (index, field) {
            result *= parseFloat($(field).val());
        });

        result = result / 1000000;

        if (result < 0.001) {
            result = 0.001;
        }

        return result;
    }

    calculateSize(volume) {
        let result = Math.pow(volume * 1000000, 1/3).toFixed();

        if (result < 1) {
            result = 1;
        }

        return result;
    }

    calculatePlacesWeightAndVolume() {
        let weight = 0
        let volume = 0;

        $('.place').each((index, e) => {
            weight += this._checkNumberIsNaN(parseFloat($(e).find('input[data-type="weight"]').val()));
            volume += this._checkNumberIsNaN(parseFloat($(e).find('input[data-type="volume"]').val()));
        })

        $('span.all-weight').text(weight.toFixed(2));
        $('span.all-volume').text(volume.toFixed(3));
    }

    _checkNumberIsNaN(number) {
        if (isNaN(number)) {
            return 0
        }

        return number;
    }

    pushResult(result) {
        if (result.status) {
            $(this.res_container).find('.loader-circle').fadeOut();

            let list_services = $(this.res_container).find('.list-services')

            $(this.res_container).find('.result').slideDown();

            list_services.empty();

            $(this.res_container).find('#total').html(result.price);

            result.services.forEach(function (service) {
                list_services.append('<li class="service-group">' + service.title + '</li>');

                service.items.forEach(function (item) {
                    list_services.append('<li><span class="left">' + item.name + '</span><span class="right">' + item.value + '₽</span></li>');
                })
            });

            let list_dates = $(this.res_container).find('.list-dates');

            list_dates.empty();

            if (result.mindeliverydate) {
                list_dates.append('<li><span class="left">Расчетная дата доставки</span><span class="right">' + result.mindeliverydate + '</span></li>');
            }

            if (result.mindeliverydays) {
                list_dates.append('<li><span class="left">Минимальный срок доставки</span><span class="right">' + result.mindeliverydays + 'д.</span></li>');
            }

            if (result.maxdeliverydays) {
                list_dates.append('<li><span class="left">Максимальный срок доставки</span><span class="right">' + result.maxdeliverydays + 'д.</span></li>');
            }
        } else {
            $(this.res_container).find('.loader-circle').fadeOut();
            $(this.res_container).find('.empty_result').slideDown();
            Swal.fire({
                title: "Расчет недоступен!",
                text: "Воспользуйтесь формой обратной связи для получения стоимости расчета.",
                icon: "warning",
                buttons: ['Закрыть', 'Заказать расчет'],
                dangerMode: true,
            }).then((willDelete) => {
                if (willDelete) {
                    $('#cod-wrong-callback').modal('show');
                } else {
                    swal.close();
                }
            });

            let city_out = $('#meacalcform-city_out_name').val(); //город отправления
            let city_in = $('#meacalcform-city_in_name').val(); //город назначения
            let address = $('#meacalcform-address_to').val();
            let price = $('#meacalcform-price').val();
            let declared_price = $('#meacalcform-declared_price').val();
            let val = $('.all-volume').html();
            let weight = $('.all-weight').html();

            let services = '';

            $('#places input:checkbox:checked').each(function(){
                services += $(this).closest('label').find('span').html() + "\n";
            });

            let calc_data = 'Город отправления: ' + city_out + "\n" +
            'Город назначения: ' + city_in + "\n" +
            'Адрес доставки: ' + address + "\n" +
            'Стоимость товаров: ' + price + "\n" +
            'Объявленная стоимость: ' + declared_price + "\n" +
            'Общий объем: ' + val + "\n" +
            'Общий вес: ' + weight + "\n" +
            'Услуги:' + "\n" + services;

            $('#callbackwrongcalculate-calc_data').val(calc_data);
        }
    }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
    module.exports = Calculate;
}
